import React from 'react';

import { ISCBImageOnly } from 'types/interfaces/sulu/IContentBlocks';

const ImageOnly = ({ media }: ISCBImageOnly) => (
  <img src={media.url} alt={media.description || media.title} />
);

export default ImageOnly;
